import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import "./header.less";

class nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      click: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    if (this.state.click === false) {
      this.setState({
        click: true,
      });
    } else {
      this.setState({
        click: false,
      });
    }
  };

  render() {
    return (
      <div className="appHead">
        <header>
          <nav className="navbar">
            <div className="nav-container">
              <Link to="/" className="nav-logo">
               <h1><span className="tLogo">T</span>efe</h1>
              </Link>

              <ul className={this.state.click ? "nav-menu active" : "nav-menu"}>
                <li className="nav-item">
                  <NavLink
                    to="/"
                    className="nav-links"
                    onClick={this.handleClick}
                    // style={{ color: color.sec }}
                  >
                    <>Home</>
                    <RightOutlined className="d-none" />
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/about"
                    className="nav-links"
                    onClick={this.handleClick}
                    // style={{ color: color.sec }}
                  >
                    About Me
                    <RightOutlined className="d-none" />
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/projects"
                    className="nav-links"
                    onClick={this.handleClick}
                    // style={{ color: color.sec }}
                  >
                    Projects
                    <RightOutlined className="d-none" />
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to="/blog"
                    className="nav-links"
                    onClick={this.handleClick}
                    // style={{ color: color.sec }}
                  >
                    Blog
                    <RightOutlined className="d-none" />
                  </NavLink>
                </li>
              
              </ul>
              <div className="nav-icon" onClick={this.handleClick}>
             { this.state.click ? <Icon icon="clarity:close-line" color="black" />: <Icon icon="entypo:menu" />}
                {/* <i
                  className={this.state.click ? "fas fa-times" : "fas fa-bars"}
                  style={{ color: color.sec }}
                ></i> */}
              </div>
            </div>
          </nav>
        </header>
      </div>
    );
  }
}

export default nav;
